export const RECRUITERS_1_CONSTANTS = {
  DEFAULT_ROW: {
    id: "1",
    meta_title: "Industry Leading Companies",
    meta_title_color: "#000000",
    meta_description: "Our graduates are recruited by top companies across various industries.",
    meta_description_color: "#666666",
    meta_background_color: "#FFF3F3",
    meta_hover_color: "#0a3d5b",
    meta_text_hover_color: "#FFFFFF",
    meta_priority: 1,
    meta_status: true,
  },    
  RECRUITERS_FIELDS_CONFIG: [
    {
      fieldName: "background_color",
      label: "Background Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter background color (e.g., #FFFFFF)",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "title",
      label: "Recruiters Title",
      value: "Our Top Recruiters",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Recruiters Title",
      required: false,
      defaultValue: "Our Top Recruiters",
    },
    {
      fieldName: "title_text_color",
      label: "Title Text Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter title text color (e.g., #000000)",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "desktop_bg_image",
      label: "Desktop Background Image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Desktop Background Image",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "mobile_bg_image",
      label: "Mobile Background Image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Mobile Background Image",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "alt_image",
      label: "Alt Image Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Alt Image Text",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "cta_button_text",
      label: "CTA Button Text",
      value: "Learn More",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter CTA button text",
      required: false,
      defaultValue: "Learn More",
    },
    {
      fieldName: "cta_button_text_color",
      label: "CTA Button Text Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter CTA button text color (e.g., #FFFFFF)",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "cta_button_color",
      label: "CTA Button Color",
      value: "#BE2330",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter CTA button color (e.g., #BE2330)",
      required: false,
      defaultValue: "#BE2330",
    },
    {
      fieldName: "cta_button_icon",
      label: "CTA Button Icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload CTA button icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "cta_button_icon_alt",
      label: "CTA Button Icon Alt Text",
      value: "Learn more",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter CTA button icon alt text",
      required: false,
      defaultValue: "Learn more",
    },
    {
      fieldName: "status",
      label: "Recruiters Status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enter Recruiters Status",
      defaultValue: false,
    }
  ],
  METADATA_FIELDS: [
    {
      header: "Title",
      fieldName: "meta_title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Title",
    },
    {
      header: "Title Color",
      fieldName: "meta_title_color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter title color (e.g., #000000)",
    },
    {
      header: "Description",
      fieldName: "meta_description",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter Description",
    },
    {
      header: "Description Color",
      fieldName: "meta_description_color",
      value: "#666666",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter description color (e.g., #666666)",
    },
    {
      header: "Section Background Color",
      fieldName: "meta_background_color",
      value: "#ffffff",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter background color (e.g., #ffffff)",
    },
    {
      header: "Section Hover Color",
      fieldName: "meta_hover_color",
      value: "#f5f5f5",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter hover color (e.g., #f5f5f5)",
    },
    {
      header: "Hover Text Color",
      fieldName: "meta_text_hover_color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter hover text color (e.g., #FFFFFF)",
    },
    {
      header: "Priority",
      fieldName: "meta_priority",
      value: "",
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Enter Priority",
      required: true,
    },
    {
      header: "Status",
      fieldName: "meta_status",
      value: "",
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enter Status",
    },
  ]
};